<template>
    <div class="footer">
        <footer>
            <div class="row footer-top">
                <!-- <xml version="1.0" encoding="utf-8"/> -->
                <!-- Generator: Adobe Illustrator 24.3.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
                <!-- <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                    viewBox="0 0 1920 200" style="enable-background:new 0 0 1920 200;" xml:space="preserve">
                <path class="st0" d="M0,172.38c0,0,249-93.38,914-50.38s434-158,1014-75v153H0V172.38z"/>
                </svg> -->
            </div>
            <div class="row footer-bottom align-items-end">
                <div class="col-md-6">
                    <a href="/">
                        <img src="../assets/images/ntnu_logo_white.png" alt="NTNU logo" />
                    </a>
                </div>
                <div class="col-md-3">
                    <h6>Trenger du hjelp?</h6>
                    <ul>
                        <li><a href="/">Om BeNet</a></li>
                        <li><a href="/information">Spørsmål og svar</a></li>
                    </ul>
                </div>
                <div class="col-md-3">
                    <h6>Andre tjenester</h6>
                    <ul>
                        <li><a href="https://www.ntnu.no">www.ntnu.no</a></li>
                        <li><a href="https://innsida.ntnu.no/">www.innsida.ntnu.no</a></li>
                    </ul>
                </div>
            </div>
            <div class="row credits">
                <div class="col-md-12 d-flex justify-content-center">
                    <p>BeNet er et bachelorprosjekt av Eirik Kvistad, Mari Rogne & Sarah Victoria Berg
                        ved NTNU i Gjøvik.
                    </p>
                </div>
            </div>
        </footer>
    </div>
</template>



<script>
    export default {
        name: 'Footer',

    }
</script>